var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarbage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237",
    transform: "translate(0.242 -0.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(6.339 4.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M58.167,1.7h-2.38V1.276A1.287,1.287,0,0,0,54.49,0H52.759a1.287,1.287,0,0,0-1.3,1.276V1.7h-2.38A1.073,1.073,0,0,0,48,2.764v.851a.429.429,0,0,0,.433.425H58.816a.429.429,0,0,0,.433-.425V2.764A1.073,1.073,0,0,0,58.167,1.7Zm-5.841-.425a.43.43,0,0,1,.433-.425H54.49a.43.43,0,0,1,.433.425V1.7h-2.6Z",
    transform: "translate(-48)",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M73.5,184a.134.134,0,0,0-.135.139l.358,7.364a1.288,1.288,0,0,0,1.3,1.215h6.586a1.288,1.288,0,0,0,1.3-1.215l.358-7.364a.134.134,0,0,0-.135-.139Zm6.549,1.063a.434.434,0,0,1,.867,0v5.529a.434.434,0,0,1-.867,0Zm-2.168,0a.434.434,0,0,1,.867,0v5.529a.434.434,0,0,1-.867,0Zm-2.168,0a.434.434,0,0,1,.867,0v5.529a.434.434,0,0,1-.867,0Z",
    transform: "translate(-72.69 -179.109)",
    fill: "#343333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbage);
export default __webpack_public_path__ + "static/media/garbage.6a56070a77ca122e8ffa159c0f7fd79a.svg";
export { ForwardRef as ReactComponent };